<template>
  <v-container v-if="clinicId">
    <ClinicProfileDetails :id="clinicId" />
  </v-container>
  <v-container v-else>
    <v-alert type="warning" outlined> No clinic assigned to your account </v-alert>
  </v-container>
</template>

<script>
import ClinicProfileDetails from '@/views/ClinicProfile/ClinicProfileDetails.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'MyClinic',
  components: {
    ClinicProfileDetails,
  },
  computed: {
    ...mapGetters('auth', ['clinicId', 'isClinicStaff']),
  },
};
</script>
